import { useCallback, useState } from "react";
import { useDisruptionStyles, useModuleBEM } from "@b2bportal/core-themes";
import type { ITimeRange } from "@b2bportal/core-types";
import { CoreDisruptionComponent } from "@b2bportal/core-types";
import { Slider } from "@tenant/ui";
import defaultStyles from "./DisruptionExerciseTimeWindowSlider.module.scss";

interface DisruptionExerciseTimeWindowSliderProps {
  onChange: (min: number, max: number) => void;
  timeRange?: ITimeRange;
  label?: string;
  type: "singleThumb" | "doubleThumb" | "normal";
  sliderMax: number;
  sliderMin: number;
  getLabel?: (value: number) => string;
}

export const DisruptionExerciseTimeWindowSlider = (
  props: DisruptionExerciseTimeWindowSliderProps
) => {
  const { onChange, timeRange, label, type, sliderMax, sliderMin, getLabel } =
    props;
  const [value, setValue] = useState(timeRange);
  const COMPONENT_KEY =
    CoreDisruptionComponent.DisruptionExerciseTimeWindowSlider;
  const styles = useDisruptionStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const handleChange = useCallback(
    (min: number, max: number) => {
      setValue({ min: min, max: max });
      onChange(min, max);
    },
    [onChange]
  );

  const formatLabel = (val: number) =>
    getLabel ? getLabel(val) : val.toString();

  return (
    <div className={cn("disruptionSliderContainer")}>
      <span className={cn("sliderTitle")}>{label}</span>
      <div className={cn("sliderValues")}>
        <span>{formatLabel(value?.min ?? 0)}</span>
        <span>{formatLabel(value?.max ?? 0)}</span>
      </div>
      <Slider
        min={sliderMin}
        max={sliderMax}
        ariaLabel=""
        value={[value?.min ?? 0, value?.max ?? sliderMax]}
        step={1}
        onValueChange={(val) => handleChange(val[0], val[1])}
        minStepsBetweenThumbs={1}
        inverted={type === "singleThumb"}
        className={cn("timeWindowSliderContainer")}
      />
    </div>
  );
};

export default DisruptionExerciseTimeWindowSlider;
